<template>
  <section class="content-width">
    <ul class="work-list">
        <!-- VR Studio -->
        <!-- RE Creates -->
      <li>
        <img src="@/assets/recreates.jpg" target="_blank">
        <h3>Real Estate Creates</h3>
        <p>Architected and developed web app that lets real estate agents edit and post to social media content in templates uploaded by graphic designers.</p>
        <ul>
          <li>Built with <a href="https://vuejs.org/" target="_blank">Vue.js</a>.</li>
          <li>Developed custom template editing engine.</li>
        </ul>
      </li>
      <li>
        <div class="image-container"><img src="@/assets/surfaceshowcase.jpg"></div>
        <h3>Surface Showcase</h3>
        <p>Working at <a href="https://i8studios.com" target="_blank">i8studios</a>, built a 3D guided selector quiz and virtual showcase for Microsoft Surface.</p>
        <ul>
          <li>Built with <a href="https://www.babylonjs.com" target="_blank">Babylon.js</a></li>
          <li>Hosted and developed using Azure services</li>
        </ul>
      </li>
      <li>
        <a class="image-container" href="https://youtu.be/DnSSW7T65tc" target="_blank"><img src="@/assets/bently.jpg"></a>
        <h3><a href="https://youtu.be/DnSSW7T65tc" target="_blank">Bently Nevada AR Landscape</a></h3>
        <p>
          Working with <a href="https://www.rationalcx.com/" target="_blank">Rational</a>, developed a beautiful event booth AR experience for their client, Bently Nevada.
        </p>
        <ul>
          <li>Built on <a href="https://developer.apple.com/augmented-reality/arkit/" target="_blank">ARKit</a></li>
          <li>Watch <a href="https://youtu.be/DnSSW7T65tc" target="_blank">demo video</a> of experience</li>
        </ul>
      </li>
      <li>
        <a class="image-container" href="https://www.tryb.app/" target="_blank"><img src="@/assets/tryb.png"></a>
        <h3><a href="https://www.tryb.app/" target="_blank">Tryb</a></h3>
        <p>Social network for gathering friends to hang out! Developed for Tryb, Inc.</p>
        <ul>
          <li>Developed iOS client</li>
          <li>Developed backend</li>
          <li>Developed web frontend</li>
          <li>Started Android client</li>
        </ul>
      </li>
      <li>
        <a class="image-container" href="https://github.com/andreyrd/ListLauncher" target="_blank">
          <img src="@/assets/list-launcher.png">
        </a>
        <h3><a href="https://github.com/andreyrd/ListLauncher" target="_blank">List Launcher</a></h3>
        <p>Simple, no nonsense Android home screen replacement.</p>
        <ul>
          <li>Under 50kb</li>
          <li>Written in Java</li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import '@/styles/sizes.scss';

.work-list {
  display: flex;
  margin: 48px -16px;
  padding: 0;
  flex-wrap: wrap;

  > li {
    display: block;
    margin: 16px;
    padding: 0;
    width: calc(33% - 32px);

    @include break-tablet {
      width: calc(50% - 32px);
    }

    @include break-phone {
      width: 100%;
    }

    .image-container {
      display: block;
      overflow: hidden;
    }

    img {
      width: 100%;
      height: auto;
      transition: transform 1s;

      &:hover {
        transform: scale(1.03);
      }
    }

    h3 {
      margin: 12px 0 6px;
    }

    p { 
      margin: 6px 0;
    }
  }
}
</style>
